import {useOutletContext} from 'react-router-dom';
import {Alert} from 'antd';
import {CheckCircleFilled} from '@ant-design/icons';
import styles from './AiHelpDesk.module.scss';
import {TicketsTable} from './components/TicketsTable';
import {TicketCard} from './components/TicketCard';
import {TicketCardSkeleton} from './components/TicketCardSkeleton';
import {TicketsChatView} from './components/TicketsChatView';

export const MyTickets = ({
  emptyTitle,
  emptyMessage = 'No tickets assigned to you.',
}) => {
  const {
    viewMode,
    tickets,
    ticketsLoading,
    listSkip,
    currentPage,
    pageSize,
    totalTickets,
    onPageChange,
    refetchTickets,
    chatTickets,
    chatHasMore,
    chatLoadingMore,
    onChatLoadMore,
  } = useOutletContext();

  if (listSkip) {
    return (
      <div className={styles.tabContent}>
        <Alert
          type="info"
          showIcon
          message="Sign in required"
          description="Your admin session must include a user id to load assigned tickets."
        />
      </div>
    );
  }

  const renderContent = () => {
    if (viewMode === 'chat') {
      return (
        <TicketsChatView
          tickets={chatTickets}
          loading={ticketsLoading && chatTickets.length === 0}
          emptyMessage={emptyMessage}
          hasMore={chatHasMore}
          loadingMore={chatLoadingMore}
          onLoadMore={onChatLoadMore}
        />
      );
    }

    if (viewMode === 'list') {
      return (
        <TicketsTable
          tickets={tickets}
          loading={ticketsLoading}
          currentPage={currentPage}
          pageSize={pageSize}
          total={totalTickets}
          onPageChange={onPageChange}
          onChanged={refetchTickets}
        />
      );
    }

    if (ticketsLoading) {
      return (
        <div className={styles.gridView}>
          {[...Array(6)].map((_, i) => (
            <TicketCardSkeleton key={i} />
          ))}
        </div>
      );
    }

    if (tickets.length === 0 && emptyTitle) {
      return (
        <div className={styles.emptyState}>
          <CheckCircleFilled className={styles.emptyIcon} />
          <h3>{emptyTitle}</h3>
          <p>{emptyMessage}</p>
        </div>
      );
    }

    if (tickets.length === 0) {
      return (
        <div style={{textAlign: 'center', padding: '48px', color: '#64748b'}}>
          {emptyMessage}
        </div>
      );
    }

    return (
      <div className={styles.gridView}>
        {tickets.map(ticket => (
          <TicketCard
            key={ticket.id}
            ticket={ticket}
            onChanged={refetchTickets}
          />
        ))}
      </div>
    );
  };

  return <div className={styles.tabContent}>{renderContent()}</div>;
};
